/**
 * Xizmatlar reyestri.
 *
 * Kontent fayllari (`./<slug>.js`) `require.context` orqali avtomatik
 * topiladi — yangi fayl qo'shilsa, sahifa o'zi paydo bo'ladi. Shu sababli
 * reyestrdagi xizmat kontentsiz ham turishi mumkin (hali yozilmagan).
 */

// Har bir xizmat: slug (uz URL), ru URL slug'i, guruh, ikonka.
export const SERVICES = [
    // ── Veb-saytlar ─────────────────────────────────────────────
    { slug: 'korporativ-saytlar', ru: 'korporativnye-sayty', group: 'web', icon: 'globe' },
    { slug: 'internet-dokonlar', ru: 'internet-magaziny', group: 'web', icon: 'cart' },
    { slug: 'landing-page', ru: 'landing-page', group: 'web', icon: 'target' },
    { slug: 'vizitka-saytlar', ru: 'sayt-vizitka', group: 'web', icon: 'card' },
    { slug: 'startap-saytlar', ru: 'sayty-dlya-startapov', group: 'web', icon: 'rocket' },

    // ── Ilovalar va tizimlar ────────────────────────────────────
    { slug: 'mobil-ilova', ru: 'mobilnye-prilozheniya', group: 'apps', icon: 'phone' },
    { slug: 'desktop-ilova', ru: 'desktop-prilozheniya', group: 'apps', icon: 'monitor' },
    { slug: 'crm-tizimlar', ru: 'crm-sistemy', group: 'apps', icon: 'pipeline' },
    { slug: 'erp-tizimlar', ru: 'erp-sistemy', group: 'apps', icon: 'layers' },
    { slug: 'telegram-bot', ru: 'telegram-boty', group: 'apps', icon: 'send' },
    { slug: 'veb-ilovalar', ru: 'veb-prilozheniya', group: 'apps', icon: 'window' },

    // ── Sun'iy intellekt ────────────────────────────────────────
    { slug: 'sun-iy-intellekt', ru: 'iskusstvennyy-intellekt', group: 'ai', icon: 'spark' },
    { slug: 'ai-agent', ru: 'ai-agent', group: 'ai', icon: 'agent' },
    { slug: 'computer-vision', ru: 'computer-vision', group: 'ai', icon: 'eye' },
    { slug: 'ai-integratsiya', ru: 'ai-integraciya', group: 'ai', icon: 'plug' },

    // ── Marketing va o'sish ─────────────────────────────────────
    { slug: 'seo', ru: 'seo', group: 'growth', icon: 'trend' },
    { slug: 'google-ads', ru: 'google-ads', group: 'growth', icon: 'megaphone' },
    { slug: 'google-business', ru: 'google-business', group: 'growth', icon: 'pin' },

    // ── Qo'shimcha xizmatlar ────────────────────────────────────
    { slug: 'ux-ui-dizayn', ru: 'ux-ui-dizayn', group: 'support', icon: 'pen' },
    { slug: 'biznes-avtomatlashtirish', ru: 'avtomatizaciya-biznesa', group: 'support', icon: 'gear' },
    { slug: 'it-autsorsing', ru: 'it-autsorsing', group: 'support', icon: 'team' },
    { slug: 'texnik-qollab-quvvatlash', ru: 'tehnicheskaya-podderzhka', group: 'support', icon: 'shield' },
];

/** Menyu guruhlari — tarjima kalitlari `service-group-*` */
export const SERVICE_GROUPS = [
    { key: 'web', i18n: 'service-group-web' },
    { key: 'apps', i18n: 'service-group-apps' },
    { key: 'ai', i18n: 'service-group-ai' },
    { key: 'growth', i18n: 'service-group-growth' },
    { key: 'support', i18n: 'service-group-support' },
];

// Kontent modullarini avtomatik yig'ish (faqat mavjudlari).
const ctx = require.context('./', false, /^\.\/(?!_|index)[a-z0-9-]+\.js$/);

const contentBySlug = ctx.keys().reduce((acc, key) => {
    const slug = key.replace('./', '').replace('.js', '');
    const mod = ctx(key);
    acc[slug] = mod.default || mod;
    return acc;
}, {});

/** Kontenti yozilgan xizmatlargina — menyu va sitemap shulardan quriladi. */
export const PUBLISHED = SERVICES.filter((s) => Boolean(contentBySlug[s.slug]));

/** @param {string} slug @param {'uz'|'ru'} lang */
export function getServiceContent(slug, lang) {
    const entry = contentBySlug[slug];
    if (!entry) return null;
    return entry[lang] || entry.uz || null;
}

/** uz slug yoki ru slug bo'yicha xizmatni topadi. */
export function findService(slug) {
    return SERVICES.find((s) => s.slug === slug || s.ru === slug) || null;
}

/** @param {'uz'|'ru'} lang — yo'l shakli src/lib/i18n-routes.js da */
export function servicePath(service, lang) {
    return lang === 'ru' ? `/ru/uslugi/${service.ru}` : `/xizmatlar/${service.slug}`;
}

export function groupedServices() {
    return SERVICE_GROUPS.map((g) => ({
        ...g,
        items: PUBLISHED.filter((s) => s.group === g.key),
    })).filter((g) => g.items.length > 0);
}

export default SERVICES;
